<template>
  <div class="table-box">
    <a-table
      :row-selection="rowSelection"
      :columns="info.columns"
      :data-source="info.list"
      :pagination="pagination"
      :rowKey="info.rowKey || 'id'"
      :loading="{ spinning: info.loading, tip: info.loadingTip || '正在加载中', size: 'large' }"
      :scroll="info.tableScroll"
    >
      <template v-for="item in info.renderSlot" :key="item" #[item]="{record, text}">
        <slot :name="item" :record="record" :text="text" />
      </template>
    </a-table>
    <a-back-top
      v-if="!info.hideBackTop"
      title="点我回到顶部"
      style="right: 50px; bottom: 60px"
      :target="backTopTarget"
    />
  </div>
</template>
<script>
import handler from './handler'
export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      searchValue: '',
      pagination: {
        hideOnSinglePage: this.info.hideOnSinglePage || false,
        current:  this.info.page || 1,
        pageSize: this.info.pageSize || 20,
        showQuickJumper: this.info.showQuickJumper || true,
        showSizeChanger: this.info.showSizeChanger || true,
        pageSizeOptions: this.info.pageSizeOptions || ['10', '20', '50', '100', '200'],
        showTotal: this.info.showTotal || ((total) => `共 ${total} 条数据`),
        onChange: (current, size) => this.changePage(current, size),
        onShowSizeChange: (current, size) => this.changePage(current, size),
        rowSelection: null
      }
    }
  },
  methods: {
    changePage(currentPage, size) {
      this.pagination.current = currentPage
      this.pagination.pageSize = size
      this.$emit('ChangePage', currentPage, size)
    },
    backTopTarget() {
      return document.querySelector(this.info.tableBodyClass || '.table-box .ant-table-body')
    }
  },
  computed: {
    rowSelection() {
      return handler.rowSelection(this)
    }
  },
  watch: {
    'info.total'(count) {
      this.pagination.total = count
    },
    'info.page'(page){
      this.pagination.current = page
    },
    'info.pageSize'(pageSize){
      this.pagination.pageSize = pageSize
    }
  }
}
</script>
<style scoped lang='less'>
@import './index';
</style>